/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import _ from 'lodash'
import { Link, withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { observer, inject } from 'mobx-react'
import { Avatar } from 'antd'
import { SIDEBAR_MENUS } from '../../../constants/navigations'

import BarangayName from '../../../components/Custom/BarangayName'
import BarangayLogo from '../../../components/Custom/BarangayLogo'
import SystemUserAvatar from '../../../components/Custom/SystemUserAvatar'
import ViewUserProfile from '../../../components/Modals/viewUserDetails'
import NotificationBell from '../../../components/Custom/NotificationsBell'

import ChangeAccountPassword from '../../../components/Custom/ChangePassword'

class HeaderTemplate extends React.Component {

	constructor(props) {
		super(props)

		const { location } = props
		this.state = {
			isOpen: false,
			isViewProfileShown: false,
			isChangePasswordShown: false
		}
	}

	render() {
		const { isViewProfileShown, isChangePasswordShown } = this.state
		const { location, AuthStore } = this.props
		const { pathname } = location
		const { userDetails, toArray, user_type } = AuthStore
		const mUserDetails = toArray(userDetails) || {}

		const filteredNavigations = SIDEBAR_MENUS.filter((i) => _.includes(i.access_role, user_type))
		return (
			<header id="topnav">
				<div className="navbar-custom">
					<div className="container-fluid">
						<ul className="list-unstyled topnav-menu float-right mb-0">

							<li className="dropdown notification-list">
								<a className="navbar-toggle nav-link">
									<div className="lines">
										<span></span>
										<span></span>
										<span></span>
									</div>
								</a>
							</li>

							{/* <li className='notification-list'>
								<a className="nav-link dropdown-toggle  waves-effect waves-light" onClick={() => {
									var elem = document.getElementById('root')
									if (!document.fullscreenElement && !document.mozFullScreenElement &&
										!document.webkitFullscreenElement && !document.msFullscreenElement) {
										if (elem.requestFullscreen) {
											elem.requestFullscreen()
										} else if (elem.msRequestFullscreen) {
											elem.msRequestFullscreen()
										} else if (elem.mozRequestFullScreen) {
											elem.mozRequestFullScreen()
										} else if (elem.webkitRequestFullscreen) {
											elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
										}
									} else {
										if (document.exitFullscreen) {
											document.exitFullscreen()
										} else if (document.msExitFullscreen) {
											document.msExitFullscreen()
										} else if (document.mozCancelFullScreen) {
											document.mozCancelFullScreen()
										} else if (document.webkitExitFullscreen) {
											document.webkitExitFullscreen()
										}
									}
								}}>
									<i className="mdi mdi-fullscreen noti-icon"></i>
								</a>
							</li> */}

							<NotificationBell user_uid={mUserDetails.uid} />

							<li className="dropdown notification-list">
								<a className="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
									{/* <img src="/assets/images/users/avatar-1.jpg" className="rounded-circle" alt={mUserDetails.full_name}/> */}
									<SystemUserAvatar size={45} user_uid={mUserDetails.uid}/>
								</a>
								<div className="dropdown-menu dropdown-menu-right profile-dropdown ">
									<div className="dropdown-header noti-title" style={{ whiteSpace: 'pre-wrap' }}>
										<h6 className="text-overflow m-0">Welcome {mUserDetails.full_name} !</h6>
									</div>

									<a href="javascript:void(0);" className="dropdown-item notify-item" onClick={() => {
										this.setState({ isViewProfileShown: true })
									}}>
										<i className="fe-user"></i>
										<span>Profile</span>
									</a>

									<a href="javascript:void(0);" className="dropdown-item notify-item" onClick={() => {
										this.setState({ isChangePasswordShown: true })
									}}>
										<i className="fe-settings"></i>
										<span>Change Password</span>
									</a>

									{/* <div className="dropdown-divider"></div> */}

									<a href="javascript:void(0);" onClick={() => AuthStore.logout()} className="dropdown-item notify-item">
										<i className="fe-log-out"></i>
										<span>Logout</span>
									</a>

								</div>
							</li>

							{/* <li className="dropdown notification-list">
								<a href="javascript:void(0);" className="nav-link right-bar-toggle waves-effect waves-light">
									<i className="fe-settings noti-icon"></i>
								</a>
							</li> */}

						</ul>

						<div className="logo-box">
							<h2 style={{ letterSpacing: 5, color: 'white', marginTop: '12px', fontFamily: 'Verdana' }}><BarangayLogo width={50} height='auto' /> Barangay <BarangayName /> Management System</h2>
						</div>

					</div>
				</div>

				<div className="topbar-menu">
					<div className="container-fluid">
						<div id="navigation">
							<ul className="navigation-menu">

								{
									filteredNavigations.map((navi, i) => {
										if (!_.has(navi, 'subs')) {
											const isActiveMenu = _.isEqual(pathname, navi.link) ? 'active' : null
											return (
												<li key={i} className={`has-submenu ${isActiveMenu}`}>
													<Link to={navi.link}>
														<i className={navi.icon_url}></i>{navi.name}
													</Link>
												</li>
											)
										} else {
											const filteredSubNavigations = navi.subs.filter((o) => _.includes(o.access_role, user_type))
											let isParentMenuActive = _.find(navi.subs, i => _.isEqual(i.link, pathname) || (_.has(i, 'subs') && _.find(i.subs, k => _.isEqual(k.link, pathname)))) ? 'active' : null
											return (
												<li key={i} className={`has-submenu ${isParentMenuActive}`}>
													<a href="#">
														<i className={navi.icon_url}></i>{navi.name} <div className="arrow-down"></div>
													</a>
													<ul className="submenu">
														{
															filteredSubNavigations.map((subNavi, j) => {
																if (!_.has(subNavi, 'subs')) {
																	const isActiveMenu = _.isEqual(pathname, subNavi.link) ? 'active' : null
																	return (
																		<li key={j} className={isActiveMenu}>
																			<Link to={subNavi.link}>
																				{subNavi.name}
																			</Link>
																		</li>
																	)
																} else {
																	const filteredSub2Navigations = subNavi.subs.filter((o) => _.includes(o.access_role, user_type))
																	let isParent2MenuActive = _.find(subNavi.subs, i => _.isEqual(i.link, pathname)) ? 'active' : null
																	return (
																		<li key={j} className={`has-submenu ${isParent2MenuActive}`}>
																			<a href="#">
																				<i className={subNavi.icon_url}></i>{subNavi.name} <div className="arrow-down"></div>
																			</a>
																			<ul className="submenu">
																				{
																					filteredSub2Navigations.map((subNavi2, k) => {
																						const isActiveMenu2 = _.isEqual(pathname, subNavi2.link) ? 'active' : null
																						return (
																							<li key={k} className={isActiveMenu2}>
																								<Link to={subNavi2.link}>
																									{subNavi2.name}
																								</Link>
																							</li>
																						)
																					})
																				}
																			</ul>
																		</li>
																	)
																}
															})
														}
													</ul>
												</li>
											)
										}
									})
								}

							</ul>

							<div className="clearfix"></div>
						</div>
					</div>
				</div>
				{
					isViewProfileShown &&
					<ViewUserProfile 
						user_uid={mUserDetails.uid}
						visible={isViewProfileShown}
						onCancel={() => this.setState({ isViewProfileShown: false })}
					/>
				}
				{
					isChangePasswordShown &&
					<ChangeAccountPassword 
						user_uid={mUserDetails.uid}
						visible={isChangePasswordShown}
						onCancel={() => this.setState({ isChangePasswordShown: false })}
					/>
				}
			</header>
		)
	}
}

const composed = compose(
	withRouter,
	inject('AuthStore'),
	observer,
)

export default composed(HeaderTemplate)
